import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import About from "./pages/About";
import Resumes from "./pages/Resumes";
import Contact from "./pages/Contact";
import Apps from "./pages/Apps";
import Game from "./pages/Game";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Notfound from "./pages/Notfound";
import { LanguageProvider } from "./context/LanguageContext";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [location]);

  return null;
}

function App() {
  const isInvalidPath = typeof window !== 'undefined' && 
    window.location.pathname !== '/' && 
    window.location.pathname !== '';

  return (
    <LanguageProvider>
      <Router>
        <AnalyticsTracker />
        {isInvalidPath ? (
          <Routes>
            <Route path="*" element={<Notfound />} />
          </Routes>
        ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resumes />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/game" element={<Game />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/apps_privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Notfound />} />
        </Routes>
        )}
      </Router>
    </LanguageProvider>
  );
}

export default App;
